
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Popper,
    Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar, Autocomplete, ButtonGroup, Grow, ClickAwayListener, MenuList, MenuItem
} from '@mui/material';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import AddBoxIcon from '@mui/icons-material/AddBox';
// import PurchaseEntryPrint from "./PurchaseEntryPrint";
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
// import PurchaseEntryDetails from "./PurchaseEntryDetails";
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, getCNSList, getPurchaseInvoiceList, getSaleInvoiceList, getSalesRegisterReport } from "../../../actions/actions";
import DeleteSnackbar from "../../reusableComponent/DeleteSnackbar";
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import AddIcon from '@mui/icons-material/Add';
import { dateConversion } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import upload_excel from '../../../images/upload_excel.png'
import { ERPinput } from "../../reusableComponent/ErpTextField";
import { makeStyles } from "@mui/styles";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getDateFormat } from "../../reusableComponent/getDateFormat";
import download_excel from '../../../images/download_excel1.png'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import SalesRegisterPrint from "./SalesRegisterPrint";
import { BackBtn } from "../../reusableComponent/BackBtn";

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },

});


const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, filterOption } = props;
    return (
        <div className="print-source" ref={ref}>
            <SalesRegisterPrint reportPrint={value} filterOption={filterOption} />
        </div>
    );
});
const ComponentToPrintOrderWrapper = ({ reportPrint, filterOption }) => {

    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" /> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={reportPrint} filterOption={filterOption} />
            </div>
        </div>
    );
};

function SalesRegister(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);

    const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
    const [toDate, setToDate] = React.useState(dayjs(new Date()));
    const [customerName, setCustomerName] = useState(null);

    const FilterOptions = ["View Report", 'View Detail Report'];
    const [openFilter, setOpenFilter] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const customerList = useSelector(state => state.CNS.CNS)
    const rows = useSelector(state => state.salesRegister.salesRegister)

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8';
    const fileExtension = '.xlsx';
    const fileName = FilterOptions[selectedIndex] === 'View Report' ? 'SalesRegisterReport' : 'SalesRegisterDetailReport'
    const [enablePagination, setEnablePagination] = useState(false)

    const exportToExcel = () => {
        setEnablePagination(true)
        setTimeout(() => {
            const table = tableRef.current;
            const data = [];

            const headerRow = [];
            table.querySelectorAll('thead > tr > th').forEach((headerCell) => {
                const boldStyle = {
                    font: { bold: true },
                };
                const cellValue = { v: headerCell.textContent, s: boldStyle };
                headerRow.push(cellValue);
            });
            data.push(headerRow);

            table.querySelectorAll('tbody > tr').forEach((row) => {
                const rowData = [];
                row.querySelectorAll('td').forEach((cell) => {
                    rowData.push(cell.textContent);
                });
                data.push(rowData);
            });

            const ws = XLSX.utils.aoa_to_sheet(data);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'data');

            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            const blob = new Blob([excelBuffer], { type: fileType });

            FileSaver.saveAs(blob, fileName + fileExtension);
            setEnablePagination(false);
        }, 50);
    };

    const handleChangeFromDate = (newValue) => {
        setFromDate(newValue);
        dispatch(getSalesRegisterReport({ companyId: userInfo.companyId, CNS_id: customerName == null ? null : customerName.CSNId, fromDate: getDateFormat(newValue.$d), toDate: getDateFormat(toDate.$d) }))
    };

    const handleChangeToDate = (newValue) => {
        setToDate(newValue);
        dispatch(getSalesRegisterReport({ companyId: userInfo.companyId, CNS_id: customerName == null ? null : customerName.CSNId, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(newValue.$d) }))
    };

    const handleChangeCustomer = (event, newValue) => {
        setCustomerName(newValue)
        dispatch(getSalesRegisterReport({ companyId: userInfo.companyId, CNS_id: newValue == null ? null : newValue.CSNId, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
    }

    const supplierGetData = () => {
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Customer', }));
    }


    const fetchData = () => {
        dispatch(getSalesRegisterReport({ companyId: userInfo.companyId, CNS_id: customerName == null ? null : customerName.CSNId, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpenFilter(false);
    };

    const handleToggle = () => {
        setOpenFilter((prevOpen) => !prevOpen);
    };

    const handleCloseFilter = (event, reason) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpenFilter(false);
    };

    useEffect(() => {
        supplierGetData()
        fetchData()
    }, []);

    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [q, setQ] = useState("");
    const [searchParam] = useState(["CNS_Name", "CNS_Type", "basicTotal", "cgstTotal", "city", "contactPerson", "creditLimit", "creditPeriod", "emailId", "gstTotal", "gstn", "igstTotal", "invoiceDate", "invoiceNo", "inwardDate", "inwardNo", "mobileNo", "openingBalance", "orderDate", "orderNo", "panNo", "paymentStatus", "pendingAmount", "pinCode", "sgstTotal", "state", "supplierType", "taxType", "total", "transporter", "vehicleNo", "vendorCode"]);

    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }

  
    const CustomTableRow = ({ row }) => (
        <>
            <StyledTableRow
                key={row.pi_id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.invoiceNo}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`} > {dateConversion(row.invoiceDate)} </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.orderRefNo}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.orderRefDate)}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.eWayBillNo}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.customerName == null ? '-' : row.CNS_Name}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.basicTotal !== null ? row.basicTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.cgstTotal !== null ? row.cgstTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.sgstTotal !== null ? row.sgstTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.igstTotal !== null ? row.igstTotal.toFixed(2) : 'N/A'}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.total !== null ? row.total.toFixed(2) : 'N/A'}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.paymentCount === 0 ? 'Unpaid' : 'Paid'}</StyledTableCell>
            </StyledTableRow>
            {FilterOptions[selectedIndex] == "View Detail Report" && (
                <>
                    <StyledTableRow>
                        <StyledTableCell  >

                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>
                            Item Description
                        </StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>HSN Code</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Quantity</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Unit</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Rate</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>GST %</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>No. of PKG</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Batch No</StyledTableCell>
                        <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Amount</StyledTableCell>
                    </StyledTableRow>

                    {JSON.parse(row.childRows).map((row, index) => (
                        <>

                            <StyledTableRow key={row.id}>
                                <StyledTableCell >

                                </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                    {row.itemId == null ? row.itemDescription : row.itemName + ' (' + row.itemCode + ')'}
                                </StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.hsnCode}</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.quantity}</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.unit}</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.rate}</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.gst} %</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.noOfPkg}</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.batchNo}</StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>{parseFloat(row.amount).toFixed(2)}</StyledTableCell>
                            </StyledTableRow>
                        </>
                    ))}

                </>
            )}
        </>
    );
    const totalBasicAmount = rows.reduce((total, row) => total + row.basicTotal, 0);
    const totalCGST = rows.reduce((total, row) => total + row.cgstTotal, 0);
    const totalSGST = rows.reduce((total, row) => total + row.sgstTotal, 0);
    const totalIGST = rows.reduce((total, row) => total + row.igstTotal, 0);
    const totalGrossAmount = rows.reduce((total, row) => total + row.total, 0);

    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Reports', path: '/reports/' },
                    { name: 'Sales Register' },
                ]}
            />
            <Paper className={`${styles.list_container}`}>

                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={4.5} xs={12}>

                        </Grid>
                        <Grid item md={7.5} xs={12} style={{ display: 'flex', }}>
                            <Grid container spacing={1} >
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            name="fromDate"
                                            inputFormat="DD/MM/YYYY"
                                            value={fromDate}
                                            onChange={handleChangeFromDate}
                                            renderInput={(params) => (<Tooltip title="Select From Date"> <ERPinput  {...params} size='small'
                                                fullWidth /> </Tooltip>)}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={0.8} sx={{ display: 'flex', justifyContent: 'center', }}>
                                    <SyncAltIcon sx={{ fontSize: '20px', textAlign: 'center' }} />
                                </Grid>
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>

                                        <DesktopDatePicker
                                            name="toDate"
                                            inputFormat="DD/MM/YYYY"
                                            value={toDate}
                                            onChange={handleChangeToDate}
                                            renderInput={(params) => (<Tooltip title="Select To Date" > <ERPinput
                                                {...params} size='small'
                                                fullWidth /> </Tooltip>)}
                                        />

                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={5.4}>
                                    <Autocomplete sx={{ marginBottom: '10px' }}
                                        fullWidth
                                        classes={{
                                            option: classes.option,
                                        }}
                                        noOptionsText={
                                            <span className={classes.noOptionsLabel}>No options</span>
                                        }
                                        options={customerList}
                                        value={customerName}
                                        onChange={handleChangeCustomer}
                                        getOptionLabel={(option) => option.CNS_Name}
                                        getOptionSelected={(option, value) => option.id === value.CSNId}
                                        renderInput={(params) => <ERPinput required
                                            placeholder="Select Customer"
                                            {...params} />}
                                    />
                                </Grid>
                                <Grid item xs={0.8}>
                                    <Box sx={{ position: 'relative' }}>
                                        <ButtonGroup ref={anchorRef} aria-label="split button" size="large" sx={{
                                            border: 'none !important',
                                            width: '100%',
                                        }}>

                                            <Button
                                                sx={{
                                                    height: '25px',
                                                    color: 'black',
                                                    fontSize: '12px',
                                                    border: '1px solid #c0c0c0',
                                                    // width: '20%',
                                                }}
                                                variant="outlined"
                                                size="small"
                                                aria-controls={openFilter ? 'split-button-menu' : undefined}
                                                aria-expanded={openFilter ? 'true' : undefined}
                                                aria-label="select merge strategy"
                                                aria-haspopup="menu"
                                                onClick={handleToggle}
                                            >
                                                <ArrowDropDownIcon sx={{ height: '28px', }} />
                                            </Button>
                                        </ButtonGroup>
                                        <Popper
                                            sx={{
                                                zIndex: 6,
                                                // minWidth: "200px",
                                            }}
                                            open={openFilter}
                                            anchorEl={anchorRef.current}
                                            role={undefined}
                                            transition
                                            disablePortal
                                        >
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{
                                                        transformOrigin:
                                                            placement === 'bottom' ? 'center top' : 'center bottom',
                                                    }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleCloseFilter}>
                                                            <MenuList id="split-button-menu" autoFocusItem>
                                                                {FilterOptions.map((option, index) => (
                                                                    <MenuItem sx={{ fontSize: '12px' }}
                                                                        key={option}
                                                                        // disabled={index === 2}
                                                                        selected={index === selectedIndex}
                                                                        onClick={(event) => handleMenuItemClick(event, index)}
                                                                    >
                                                                        {option}
                                                                    </MenuItem>
                                                                ))}
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.5}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Download Excel File" >
                                            {/* <DownloadTableExcel
                                                filename={FilterOptions[selectedIndex] === 'View Report' ? 'SalesRegisterReport' : 'SalesRegisterDetailReport'}
                                                sheet={FilterOptions[selectedIndex] === 'View Report' ? 'Sales Register Report' : 'Sales Register Detail Report'}
                                                currentTableRef={tableRef.current}
                                            >
                                                <img src={download_excel} style={{ height: "20px", width: "20" }} />
                                            </DownloadTableExcel> */}
                                            <img src={download_excel} onClick={exportToExcel} style={{ height: "20px", width: "20" }} />
                                        </Tooltip>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.5}>
                                    <Box className={`${styles.excel_box}`}>
                                        <ComponentToPrintOrderWrapper reportPrint={rows} filterOption={FilterOptions[selectedIndex]} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 450 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Invoice No </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Invoice Date </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Order No </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Order Date </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >E-Way Bill No </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Customer Name </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} >Basic Amount  </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} >CGST  </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} >SGST </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} > IGST </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} > Gross Amount </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Payment Status </StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {
                                enablePagination === false ? (
                                    rows && rows.map((row, index) => (
                                            <CustomTableRow key={row.pi_id} row={row} />
                                        ))
                                ) : (
                                    rows.map((row, index) => (
                                        <CustomTableRow key={row.pi_id} row={row} />
                                    ))
                                )
                            }
                            {rows.length > 0 &&
                                <StyledTableRow 
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0'}}></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0'}}> </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0'}}></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0'}}></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0'}}> </StyledTableCell>
                                    <StyledTableCell align="right" style={{ fontSize: '16px', fontWeight: 'bold',borderTop:'2px solid #c0c0c0' }}>  Total :</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0'}}> {totalBasicAmount !== null ? totalBasicAmount.toFixed(2) : 'N/A'}</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0'}}> {totalCGST !== null ? totalCGST.toFixed(2) : 'N/A'}</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0'}}> {totalSGST !== null ? totalSGST.toFixed(2) : 'N/A'}</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0'}}> {totalIGST !== null ? totalIGST.toFixed(2) : 'N/A'}</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0'}}> {totalGrossAmount !== null ? totalGrossAmount.toFixed(2) : 'N/A'} </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0'}}> </StyledTableCell>
                                </StyledTableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                
            </Paper>

        </>
    )
}



export default SalesRegister